import ItemModel from "../item-model"
import {EntityType} from "../../../gd/const/item"

// created for compatibility with components that are using ItemModelV2
export default class ItemViewAdapter {

    private itemModel               : ItemModel;

    constructor(itemModel: ItemModel) {
        this.itemModel = itemModel
    }

    toggleCollapsed() : void {
        this.isCollapsed = !this.isCollapsed
    }

    get isCollapsed() {
        return this.itemModel.isCollapsed
    }

    set isCollapsed(value: boolean) {
        this.itemModel.isCollapsed = value
    }

    get isSelected():boolean {
        return this.itemModel.isSelected
    }

    set isSelected(value: boolean) {
        this.itemModel.isSelected = value
        this.itemModel.updateLastUpdateTime()
    }

    get isFocused():boolean {
        return this.itemModel.isFocused
    }

    set isFocused(value: boolean) {
        this.itemModel.isFocused = value
        this.itemModel.updateLastUpdateTime()
    }

    setSortPosition(sortPosition: number) {
        switch (this.itemModel.type){
            case EntityType.PROJECT:
                this.itemModel.project.sortPosition = sortPosition
                break

            case EntityType.TASK:
                this.itemModel.projectItem.sortPosition = sortPosition
                this.itemModel.task.setProjectSortPosition(this.itemModel.projectItem.projectId, sortPosition)
                break
        }
    }

    set displayNumber(value: number) {
        this.itemModel.displayNumber = value
    }

    get displayNumber() {
        return this.itemModel.displayNumber
    }
}